import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalRedirectComponent } from './auth/redirect.component';
import { AuthService } from './core/auth.service';
import { OfflineStorageService } from './shared/offline-storage.service';
import { ToastComponent } from './shared/toast.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MsalRedirectComponent, ToastComponent],
  template: `
    <router-outlet />
    <app-auth-redirect />
    <app-toast />
  `,
  styleUrl: './app.css'
})
export class App implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly offlineStorage = inject(OfflineStorageService);

  ngOnInit(): void {
    // Initialize IndexedDB for offline storage
    this.offlineStorage.initialize();

    // Start monitoring token expiration on app initialization
    this.authService.startTokenExpirationMonitoring();
  }
}
